export default __webpack_public_path__ + "static/media/question-set-image.6c53ee15.svg";